import { environment } from "src/environments/environment";

const DEMO_HOST = environment.snoots.storageEndpoint;

export async function loadDemoStorage<T = any>(
  collection: string,
  defaultValue: any = []
): Promise<T> {
  return <any>null;
}

export async function writeDemoStorage(collection: string, data: any) {}
